export function getEmailThreadProfileNextUpdatedData(prevData, data) {
  // #INFO Add necessary properties after updating profile
  return { ...prevData, labels: data.label_objs, starred: data.starred }
}

// The idwell-api thread detail carries no labels; they come from the Django
// thread profile (ID-161).
export function getEmailThreadProfileDataWithLabels(
  threadResponse,
  labelsResponse
) {
  return {
    data: { ...threadResponse.data, labels: labelsResponse.data.label_objs },
  }
}
